<template>
  <div class="center">
    <img :src="company_image_url" alt="logo" />
    <p class="label">Nom de la salle</p>
    <h1>{{ roomName }}</h1>
  </div>
</template>

<script>
export default {
  name: "room-header",
  props: {
    roomId: String,
    roomName: String,
  },
  data: function() {
    return {
      company_image_url: process.env.VUE_APP_COMPANY_IMAGE_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 0.7rem;
  opacity: 0.6;
  margin-bottom: 0.3rem;
}
h1 {
  margin-bottom: 2rem;
}
img {
  width: auto;
  max-height: 250px;
  margin-bottom: 2rem;
}
</style>
